export default "__VITE_ASSET__BJI2iPRR__"